module.exports = __webpack_public_path__ + "static/media/grph-stat-depression-dec.6731157e.svg";